/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import {Figcaption} from 'components/markdown/Figcaption';
import {MultiCodeEditorInteractive} from 'components/markdown/MultiCodeEditorInteractive';
import {Link} from 'components/elements/Link';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    code: "code",
    h2: "h2",
    pre: "pre",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "Use ", React.createElement(_components.a, {
    href: "/docs/sdk/methods/extract/attr"
  }, "attr"), " with ", React.createElement(_components.code, null, "json"), " when the target URL is already a JSON endpoint. Microlink fetches the URL, parses the full response body with ", React.createElement(_components.code, null, "JSON.parse"), ", and returns native structured data instead of a string."), "\n", React.createElement(MultiCodeEditorInteractive, {
    height: 300,
    mqlCode: {
      url: 'https://pokeapi.co/api/v2/pokemon/pikachu',
      data: {
        json: {
          attr: 'json'
        }
      },
      meta: false,
      prerender: false
    }
  }), "\n", React.createElement(Figcaption, null, "Read the parsed endpoint payload from ", React.createElement("code", null, "data.json"), "."), "\n", React.createElement(_components.h2, {
    id: "return-json-directly"
  }, "Return JSON directly"), "\n", React.createElement(_components.p, null, "Add ", React.createElement(_components.a, {
    href: "/docs/api/parameters/embed"
  }, "embed"), " with ", React.createElement(_components.code, null, "json"), " when the API URL itself should return the parsed JSON field:"), "\n", React.createElement(MultiCodeEditorInteractive, {
    height: 320,
    mqlCode: {
      url: 'https://pokeapi.co/api/v2/pokemon/pikachu',
      data: {
        json: {
          attr: 'json'
        }
      },
      meta: false,
      prerender: false,
      embed: 'json'
    }
  }), "\n", React.createElement(Figcaption, null, "The response is JSON, so a worker or backend job can consume it without reading a nested ", React.createElement("code", null, "data.json"), " field."), "\n", React.createElement(_components.p, null, "The same request as a raw URL:"), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-bash"
  }, "https://api.microlink.io?url=https://pokeapi.co/api/v2/pokemon/pikachu&data.json.attr=json&meta=false&prerender=false&embed=json\n")), "\n", React.createElement(_components.h2, {
    id: "keep-the-whole-response-body"
  }, "Keep the whole response body"), "\n", React.createElement(_components.p, null, React.createElement(_components.code, null, "attr: 'json'"), " is whole-page only. Do not combine it with ", React.createElement(_components.a, {
    href: "/docs/sdk/methods/extract/selector"
  }, "selector"), " or ", React.createElement(_components.a, {
    href: "/docs/sdk/methods/extract/selectorAll"
  }, "selectorAll"), "; Microlink parses the entire endpoint response."), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-js"
  }, "{\n  url: 'https://pokeapi.co/api/v2/pokemon/pikachu',\n  data: {\n    json: {\n      attr: 'json'\n    }\n  },\n  meta: false,\n  prerender: false\n}\n")), "\n", React.createElement(_components.p, null, "The original JSON shape is preserved as structured data. Strings that contain HTML-like text, such as ", React.createElement(_components.code, null, "\"<b>bold</b>\""), ", stay as strings and are not interpreted as DOM markup."), "\n", React.createElement(_components.h2, {
    id: "when-to-use-it"
  }, "When to use it"), "\n", React.createElement(_components.table, null, React.createElement(_components.thead, null, React.createElement(_components.tr, null, React.createElement(_components.th, null, "Need"), React.createElement(_components.th, null, "Use"))), React.createElement(_components.tbody, null, React.createElement(_components.tr, null, React.createElement(_components.td, null, "Fetch a REST API through Microlink"), React.createElement(_components.td, null, React.createElement(_components.code, null, "attr: 'json'"))), React.createElement(_components.tr, null, React.createElement(_components.td, null, "Keep response metadata next to the parsed payload"), React.createElement(_components.td, null, "leave ", React.createElement(_components.code, null, "embed"), " out")), React.createElement(_components.tr, null, React.createElement(_components.td, null, "Return the parsed field as the API response"), React.createElement(_components.td, null, "add ", React.createElement(_components.code, null, "embed: 'json'"))), React.createElement(_components.tr, null, React.createElement(_components.td, null, "Extract content from an HTML page"), React.createElement(_components.td, null, "use ", React.createElement(_components.code, null, "text"), ", ", React.createElement(_components.code, null, "markdown"), ", or ", React.createElement(_components.code, null, "html"), " instead")))), "\n", React.createElement(_components.h2, {
    id: "next-step"
  }, "Next step"), "\n", React.createElement(_components.p, null, "Use ", React.createElement(Link, {
    href: "/docs/guides/data-extraction/defining-rules#extract-json",
    children: "Data extraction: Extract JSON"
  }), " for the full rule behavior. Use ", React.createElement(Link, {
    href: "/docs/guides/content-conversion/url-to-text",
    children: "URL to Text"
  }), ", ", React.createElement(Link, {
    href: "/docs/guides/content-conversion/url-to-markdown",
    children: "URL to Markdown"
  }), ", or ", React.createElement(Link, {
    href: "/docs/guides/content-conversion/url-to-html",
    children: "URL to HTML"
  }), " when the source is a web page, PDF, or office document instead of a JSON endpoint."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
